import React, { useState } from 'react'

import styles from './filePage.module.css'
import FileManage from '../../components/file/FileManage'

const FilePage = () => {
    const [page, setPage] = useState('counsel')

    return (
        <>
            <div className={styles.container}>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <button
                            type='button'
                            className={page === 'counsel' ? 'nav-link active' : 'nav-link'}
                            onClick={() => { setPage('counsel') }}
                        >상담 관련 파일</button>

                    </li>
                    <li className="nav-item">
                        <button
                            type='button'
                            className={page === 'schoolRecord' ? 'nav-link active' : 'nav-link'}
                            onClick={() => { setPage('schoolRecord') }}
                        >생활기록부 관련 파일</button>
                    </li>
                </ul>

                {page === 'counsel' &&
                    <div className={styles.section}>
                        <div className=''>
                            <h4 className={styles.title}>상담 관련 파일 업로드</h4>
                        </div>

                        <FileManage type={'counsel'} />
                    </div>
                }

                {page === 'schoolRecord' &&
                    <div className={styles.section}>
                        <div className=''>
                            <h4 className={styles.title}>생활기록부 관련 파일 업로드</h4>
                        </div>

                        <FileManage type={'schoolRecord'} />
                    </div>
                }
            </div>
        </>
    )
}

export default FilePage